<template>
  <v-badge color="background">
    <template v-slot:badge>
      <v-dialog v-model="dialog" max-width="600">
        <template v-slot:activator="{on}">
          <v-icon v-on="on" color="primary">mdi-help-circle-outline</v-icon>
        </template>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{ headerTitle }}</v-card-title>
          <v-card-text class="innerText">{{ body }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Entendido</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <span>{{question}}</span>
  </v-badge>
</template>

<script>
export default {
  name: "DeclarationDialog",
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    question: String,
    headerTitle: String,
    body: String,
  },
};
</script>

<style>
.innerText {
  text-align: justify;
}
</style>
